module.exports = __webpack_public_path__ + "img/storedetails.576049a.jpg";